import { ThirdPartyEvaluationForm } from './thirdparty-evaluation-form';

export class ThirdPartyEvaluation {
    thirdPartyEvaluationId: number = 0;
    tenantId: number = 0;
    thirdPartyId: number = 0;
    stageId: number = 0;
    thirdPartyTypeId: number = 0;

    formDto: ThirdPartyEvaluationForm = new ThirdPartyEvaluationForm();

    isPendingOfAproval: boolean = false;
    // Conversation display flag
    showComments: boolean = false;

    constructor() {
    }
}